import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioSituacaoReducer(state = initialState.relatorioSituacao, action){
    switch(action.type) {
        case types.RELAT_SITUACAO_ESTRUTURA:
            
            return action.relatorioSituacao;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioSituacaoReducer.js
 **/